{
 "id": "okubo-west-b",
 "light": 0.6,
 "_note": "2x art scene: Okubo west (Koreatown streets with Golden Gai pockets), painted by client/src/hd-scene.ts with the kinds of client/src/hd-fronts-okubo-west.ts. Cosmetic only: buildings sit on existing solid tiles; no collision, shops or zones change. Tile units. Buildings stack north to south, each painting its own south wall (face rows).",
 "rect": {
  "x": 128,
  "y": 60,
  "w": 72,
  "h": 36
 },
 "buildings": [
  {
   "id": "ob-w1",
   "x": 130,
   "y": 62,
   "w": 13,
   "h": 10,
   "face": 4,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "고기",
    "color": "cyan"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     0.8
    ],
    [
     "ac",
     7,
     0.8
    ],
    [
     "okuboWestBoard",
     5,
     2.8
    ],
    [
     "vent",
     11,
     3.6
    ]
   ]
  },
  {
   "id": "ob-w2",
   "x": 130,
   "y": 72,
   "w": 13,
   "h": 10,
   "face": 3,
   "kind": "okuboWestCosmetics",
   "roof": "concrete",
   "sign": {
    "text": "미용",
    "color": "amber"
   },
   "props": [
    [
     "ac",
     1,
     1
    ],
    [
     "ac",
     2.4,
     1
    ],
    [
     "tank",
     8,
     1
    ],
    [
     "dish",
     5,
     3.6
    ],
    [
     "hut",
     9,
     4.4
    ]
   ]
  },
  {
   "id": "ob-w3",
   "x": 145,
   "y": 62,
   "w": 13,
   "h": 10,
   "face": 4,
   "kind": "hotel",
   "roof": "concrete",
   "sign": {
    "text": "ホテル",
    "color": "pink"
   },
   "props": [
    [
     "tank",
     1.4,
     1
    ],
    [
     "ac",
     7,
     1
    ],
    [
     "ac",
     8.4,
     1
    ],
    [
     "okuboWestBoard",
     3,
     3.4
    ],
    [
     "vent",
     11,
     4
    ]
   ]
  },
  {
   "id": "ob-w4n",
   "x": 145,
   "y": 72,
   "w": 6,
   "h": 5,
   "face": 3,
   "kind": "okuboWestMart",
   "roof": "ribbed"
  },
  {
   "id": "ob-w4",
   "x": 151,
   "y": 72,
   "w": 7,
   "h": 10,
   "face": 3,
   "kind": "okuboWestMart",
   "roof": "ribbed",
   "sign": {
    "text": "마트",
    "color": "cyan"
   },
   "props": [
    [
     "okuboWestFlue",
     0,
     1.2
    ],
    [
     "dish",
     4,
     1.4
    ],
    [
     "hut",
     1,
     4.4
    ]
   ]
  },
  {
   "id": "ob-e1",
   "x": 166,
   "y": 62,
   "w": 16,
   "h": 8,
   "face": 3,
   "kind": "okuboWestBbq",
   "roof": "tar",
   "sign": {
    "text": "치킨",
    "color": "pink"
   },
   "props": [
    [
     "okuboWestFlue",
     2,
     0.6
    ],
    [
     "ac",
     8,
     0.8
    ],
    [
     "okuboWestBoard",
     10,
     1.8
    ],
    [
     "vent",
     5,
     3
    ]
   ]
  },
  {
   "id": "ob-e2",
   "x": 182,
   "y": 62,
   "w": 6,
   "h": 8,
   "face": 3,
   "kind": "okuboWestCosmetics",
   "roof": "ribbed",
   "sign": {
    "text": "コスメ",
    "color": "pink"
   },
   "props": [
    [
     "ac",
     1,
     0.8
    ],
    [
     "ac",
     2.4,
     0.8
    ],
    [
     "okuboWestBoard",
     3,
     2.4
    ]
   ]
  },
  {
   "id": "ob-e2b",
   "x": 188,
   "y": 62,
   "w": 10,
   "h": 8,
   "face": 3,
   "kind": "okuboCarParkUpper",
   "roof": "concrete",
   "props": [
    [
     "dish",
     7,
     0.8
    ],
    [
     "hut",
     2,
     2
    ]
   ]
  },
  {
   "id": "ob-e3",
   "x": 166,
   "y": 70,
   "w": 10,
   "h": 12,
   "face": 4,
   "kind": "okuboWestGai",
   "roof": "tile",
   "sign": {
    "text": "酒",
    "color": "amber"
   },
   "props": [
    [
     "vent",
     2,
     1.4
    ],
    [
     "ac",
     6,
     2.6
    ]
   ]
  },
  {
   "id": "ob-e4",
   "x": 188,
   "y": 78,
   "w": 9,
   "h": 4,
   "face": 3,
   "kind": "okuboCarPark",
   "roof": "concrete",
   "props": []
  },
  {
   "id": "ob-s1",
   "x": 130,
   "y": 90,
   "w": 14,
   "h": 6,
   "face": 3,
   "kind": "apartment",
   "roof": "ribbed",
   "props": [
    [
     "ac",
     1,
     0.6
    ],
    [
     "ac",
     2.4,
     0.6
    ],
    [
     "vent",
     8,
     1.2
    ],
    [
     "dish",
     11,
     0.6
    ]
   ]
  },
  {
   "id": "ob-s2",
   "x": 144,
   "y": 90,
   "w": 14,
   "h": 6,
   "face": 3,
   "kind": "office",
   "roof": "concrete",
   "props": [
    [
     "tank",
     1.4,
     0.4
    ],
    [
     "ac",
     8,
     1
    ],
    [
     "ac",
     9.4,
     1
    ],
    [
     "okuboWestBoard",
     5,
     1.8
    ]
   ]
  },
  {
   "id": "ob-s3",
   "x": 166,
   "y": 90,
   "w": 16,
   "h": 6,
   "face": 3,
   "kind": "shutter",
   "roof": "tar",
   "props": [
    [
     "ac",
     1,
     0.6
    ],
    [
     "hut",
     6,
     0.6
    ],
    [
     "vent",
     12,
     1.6
    ],
    [
     "dish",
     14,
     0.6
    ]
   ]
  },
  {
   "id": "ob-s4",
   "x": 182,
   "y": 90,
   "w": 16,
   "h": 6,
   "face": 3,
   "kind": "karaoke",
   "roof": "concrete",
   "sign": {
    "text": "カラオケ",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     1,
     0.8
    ],
    [
     "ac",
     2.4,
     0.8
    ],
    [
     "tank",
     9,
     0.6
    ],
    [
     "okuboWestBoard",
     5,
     1.4
    ]
   ]
  }
 ],
 "lamps": [
  [
   134,
   60.5,
   "n"
  ],
  [
   150,
   60.5,
   "n"
  ],
  [
   156,
   60.5,
   "n"
  ],
  [
   168,
   60.5,
   "n"
  ],
  [
   186,
   60.5,
   "n"
  ],
  [
   194,
   60.5,
   "n"
  ],
  [
   134,
   83.6,
   "s"
  ],
  [
   150,
   83.6,
   "s"
  ],
  [
   156,
   83.6,
   "s"
  ],
  [
   168,
   83.6,
   "s"
  ],
  [
   194,
   83.6,
   "s"
  ],
  [
   134,
   88.5,
   "n"
  ],
  [
   150,
   88.5,
   "n"
  ],
  [
   168,
   88.5,
   "n"
  ],
  [
   186,
   88.5,
   "n"
  ],
  [
   194,
   88.5,
   "n"
  ],
  [
   159.6,
   64,
   "e"
  ],
  [
   164.4,
   64,
   "w"
  ],
  [
   159.6,
   72,
   "e"
  ],
  [
   164.4,
   72,
   "w"
  ],
  [
   159.6,
   78,
   "e"
  ],
  [
   164.4,
   78,
   "w"
  ],
  [
   159.6,
   92,
   "e"
  ],
  [
   164.4,
   92,
   "w"
  ]
 ]
}
